import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';
import moment from 'moment';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';

import Checkbox from '@material-ui/core/Checkbox';
import $ from "jquery";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class TypePoint extends Component {

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission } = authentication.currentUserValue;

        this.state = {
            userid: user_id,
            jwt: jwt,
            user_permission: user_permission,
            pages: [],
            addIsOpen: false,
            srcIsOpen: false,
            deleteIsOpen: false,
            updateIsOpen: false,
            warningIsOpen: false,
            content_id: '',
            warningMessage: "",
            methodOpen: '',
            add_id: '',
            add_name_th: '',
            add_name_en: '',
            src_name_th: '',
            src_name_en: '',
            add_type: '',
            add_active_status: '',
            add_img: '',
            add_no: '',
            active: true,
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            src_active: false,
            src_nonactive: false,
            file: null,
            page: 0,
            rowsPerPage: 10,
            miss_su: helpers.getUserType(user_type, "su"),
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.closeAdd = this.closeAdd.bind(this);
        this.openAdd = this.openAdd.bind(this);
        this.submitAdd = this.submitAdd.bind(this);

        this.openEdit = this.openEdit.bind(this);
        this.openView = this.openView.bind(this);

        this.change = this.change.bind(this);
        this.dataTable = this.dataTable.bind(this);
        this.submitEdit = this.submitEdit.bind(this);

        this.closeSrc = this.closeSrc.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);

        this.handleCheck = this.handleCheck.bind(this)

        this.openDelete = this.openDelete.bind(this);
        this.closeDelete = this.closeDelete.bind(this);
        this.submitDelete = this.submitDelete.bind(this);

        this.onChange = this.onChange.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);

        this.closeModelUpdate = this.closeModelUpdate.bind(this);

        this.handleActiveSrcCheck = this.handleActiveSrcCheck.bind(this)
        this.handleNonActiveSrcCheck = this.handleNonActiveSrcCheck.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

        this.closeWarning = this.closeWarning.bind(this);
        this.dataTable();
    }

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    dataTable() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            let body = `?active=${this.state.src_active}&nonactive=${this.state.src_nonactive}&name_th=${this.state.src_name_th}&name_en=${this.state.src_name_en}`
    
            fetch(config.url.API_URL + '/level_members' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    console.log("Test;asd ", data)
                    if (Array.isArray(data.data) && data.data.length) {
                        this.setState({
                            pages: [].concat(data.data)
                        });
    
                    } else {
                        this.setState({
                            pages: []
                        });
                    }
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitSrc(e) {
        this.dataTable()
        this.setState({ srcIsOpen: false });
    }

    openAdd() {
        this.setState({
            addIsOpen: true,
            methodOpen: 'add',
            add_name_th: '',
            add_name_en: '',
            add_no: '',
            add_active_status: true
        });
    }

    openEdit(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/level_members/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data;
                    this.setState({
                        add_id: data._id,
                        add_name_th: data.name_th,
                        add_name_en: data.name_en,
                        add_no: data.no,
                        images: data.img,
                        active: data.active_status
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'edit'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openView(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/level_members/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data;
                    this.setState({
                        add_id: data._id,
                        add_name_th: data.name_th,
                        add_name_en: data.name_en,
                        add_no: data.no,
                        add_active_status: data.active_status
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeDelete() {
        this.setState({ deleteIsOpen: false });
        this.dataTable();
    }

    closeWarning() {
        this.setState({ warningIsOpen: false });
        this.dataTable();
    }

    closeAdd() {
        this.setState({
            add_id: '',
            add_name: '',
            add_name_en: '',
            add_no: '',
            file: null
        });
        this.setState({ addIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.dataTable();
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_active: false,
            src_nonactive: false,
            add_name_th: '',
            add_name_en: '',
            src_name_th: '',
            src_name_en: '',
            add_no: '',
            page: 0
        });
    }

    submitAdd() {
        try {
            if (!this.state.add_name_th) {
                alert('ไม่พบข้อมูลชื่อไทย');
                return;
            }
    
            if (!this.state.add_name_en) {
                alert('ไม่พบข้อมูลชื่ออังกฤษ');
                return;
            }
    
            if (!this.state.add_no) {
                alert('ไม่พบข้อมูลลำดับ');
                return;
            }
    
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    name_th: this.state.add_name_th,
                    name_en: this.state.add_name_en,
                    no: this.state.add_no,
                    active_status: this.state.active ? 1 : 0,
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/level_members', requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (data.data.message) {
                        this.setState({
                            updateIsOpen: false,
                            warningIsOpen: true,
                            warningMessage: data.data.message,
                            file: null
                        });
                    } else {
                        this.setState({
                            updateIsOpen: true
                        });
                    }
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            this.setState({ addIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitDelete(e) {
        try {
            const requestOptions = {
                method: 'DELETE',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/level_members/' + this.state.content_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            this.setState({ deleteIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openDelete(e) {
        this.setState({
            deleteIsOpen: true,
            content_id: e.currentTarget.attributes["data-id"].value
        });
    }

    submitEdit(e) {
        try {
            if (!this.state.add_name_th) {
                alert('ไม่พบข้อมูลชื่อไทย');
                return;
            }
    
            if (!this.state.add_name_en) {
                alert('ไม่พบข้อมูลชื่ออังกฤษ');
                return;
            }
    
            if (!this.state.add_no) {
                alert('ไม่พบข้อมูลลำดับ');
                return;
            }
            
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    name_th: this.state.add_name_th,
                    name_en: this.state.add_name_en,
                    no: this.state.add_no,
                    active_status: this.state.active ? 1 : 0,
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/level_members/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        addIsOpen: false
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    onChange(e) {
        this.setState({ file: e.target.files[0] });
    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleActiveSrcCheck() {
        this.setState({
            src_active: !this.state.src_active
        });
    }

    handleNonActiveSrcCheck() {
        this.setState({
            src_nonactive: !this.state.src_nonactive
        });
    }

    render() {
        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Level Member List</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Level Member</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    <ExcelFile filename="member_level" element={(this.state.user_permission[225].permission == 1 &&
                                        <div className="btn-add text-center">Export Data</div>
                                    )}>
                                        <ExcelSheet data={this.state.pages} name="member_level">
                                            <ExcelColumn label="ชื่อไทย" value="name_th" />
                                            <ExcelColumn label="ชื่ออังกฤษ" value={(col) => col.name_en} />
                                            <ExcelColumn label="อัพเดทล่าสุด" value={(col) => col.updateby ? col.updateby : col.createby} />
                                            <ExcelColumn label="อัพเดทล่าสุด(วันที่)" value={(col) => col.updated ? moment(col.updated).format('DD/MM/YYYY H:mm น.') : moment(col.created).format('DD/MM/YYYY H:mm น.')} />
                                        </ExcelSheet>
                                    </ExcelFile>
                                    {/* {(this.state.user_permission[24].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openAdd}>เพิ่มข้อมูล</div>
                                    )} */}
                                </div>
                                {/* .card-header */}
                                <div className="card-body">
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: 'auto' }}>No</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่อไทย</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่ออังกฤษ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>วันที่สร้าง</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>สถานะ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>อัพเดทล่าสุด</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>รายละเอียด</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    {/* <StyledTableCell>{i+1}</StyledTableCell> */}
                                                                    <StyledTableCell>{i + (this.state.page * this.state.rowsPerPage) + 1  }</StyledTableCell>
                                                                    <StyledTableCell>{data.name_th}</StyledTableCell>
                                                                    <StyledTableCell>{data.name_en}</StyledTableCell>
                                                                    <StyledTableCell>{moment(data.created).format('DD/MM/YYYY H:mm น.')}</StyledTableCell>
                                                                    <StyledTableCell>{helpers.getActiveStatus(data.active_status)}</StyledTableCell>
                                                                    <StyledTableCell>{data.updateby ? data.updateby : data.createby}<br />{data.updated != undefined ? moment(data.updated).format('DD/MM/YYYY H:mm น.') : moment(data.created).format('DD/MM/YYYY H:mm น.')}</StyledTableCell>
                                                                    <StyledTableCell>
                                                                        <button className="btn-action text-center" data-id={data._id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>

                                                                        {(this.state.user_permission[25].permission == 1 &&
                                                                            <button className="btn-action text-center" data-id={data._id} onClick={this.openEdit}><img src="dist/img/icon/ic_update.png" className="btn-icon" alt="" /> Update</button>
                                                                        )}
                                                                        {/* {(this.state.user_permission[26].permission == 1 &&
                                                                            <button className="btn-action text-center" data-id={data._id} onClick={this.openDelete}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>
                                                                        )} */}
                                                                    </StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </section>
                {/* /.content */}
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อไทย</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_name_th" name="src_name_th" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่ออังกฤษ</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_name_en" name="src_name_en" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3" >
                                <div className="col-sm-3 text-right">สถานะ</div>
                                <div className="col-sm-5">
                                    <Checkbox
                                        checked={this.state.src_active}
                                        onChange={this.handleActiveSrcCheck}
                                        color="primary"
                                    /> ใช้งาน
                                    <Checkbox
                                        checked={this.state.src_nonactive}
                                        onChange={this.handleNonActiveSrcCheck}
                                        color="primary"
                                    /> ไม่ได้ใช้งาน
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="lg">
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && "เพิ่มข้อมูล") || (this.state.methodOpen === 'edit' && "แก้ไขข้อมูล") || (this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อไทย<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_name_th" name="add_name_th" defaultValue={this.state.add_name_th} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_name_th}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่ออังกฤษ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_name_en" name="add_name_en" defaultValue={this.state.add_name_en} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_name_en}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ลำดับ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_no" name="add_no" defaultValue={this.state.add_no} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_no}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">สถานะ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<p><Checkbox
                                            checked={this.state.active}
                                            onChange={this.handleCheck}
                                            color="primary"
                                        />ใช้งาน</p>)
                                        : (<div>
                                            <p>{this.state.add_active_status == 1 ? 'ใช้งาน' : 'ไม่ใช้งาน'}</p>
                                        </div>)}
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen === 'add' &&
                            (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className="btn btn-success" onClick={this.submitAdd}>เพิ่มข้อมูล</button></div>))
                            || (this.state.methodOpen === 'edit' &&
                                (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>))
                            || (this.state.methodOpen === 'view' &&
                                (<div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>))}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.warningIsOpen} onHide={this.closeWarning} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        {this.state.warningMessage}
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeWarning}>ยกเลิก</button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}